import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

export class Nuorder extends React.PureComponent<any, any> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <path d="M21.8,5v3h-0.7V5h-8.7v10.5c0,0.8,0.6,1.5,1.4,1.5H24V5H21.8z" />
                <path d="M11,15.8L0.5,5h11.1v10.6c0,0.1,0,0.2-0.2,0.3C11.4,16,11.2,16,11,15.8z" />
                <path d="M10.5,16.8c-0.1,0.1-0.2,0.2-0.3,0.2H0V5.5l10.5,10.8C10.6,16.5,10.6,16.7,10.5,16.8z" />
            </SvgIcon>
        );
    }
}

export default Nuorder;
